
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexda9eg5cyJoeRQ5OHmehC2AixU5jT5bMbtaFLXls5Y_45UMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/index.vue?macro=true";
import { default as basketNCmkoKxBjnjGNY3hhrPjTI_45e_WNVlksfT70GhS81fM8Meta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/basket.vue?macro=true";
import { default as searchkyPKJLhfo0K8VPjuFenGcNflunnngV390BamRS5of18Meta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/search.vue?macro=true";
import { default as signinu06cCdb90ST91r3y2kEFluvvpwHfWawhBYTf2t2gHakMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/signin.vue?macro=true";
import { default as successlky_45uOJxuwXTLFJ1l5Qf0ARq_23KuqxkbGZO0Kv4tuAMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/success.vue?macro=true";
import { default as checkout6dybzrTSEjdfXBQ_o3bHJk2IEAT1_45LC8VcApf7CdHO8Meta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/checkout.vue?macro=true";
import { default as _91slug_93HSCwDtVcl38HVwYoRTiecdfOQH_45GRjjE0PmF24bd_lwMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/[slug].vue?macro=true";
import { default as ropo_45plpsGoF5kq0h5tASimbd6xQAvCjhjMb9lhXHYzSjuQavA4Meta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/ropo-plp.vue?macro=true";
import { default as wishlistzgG4XUGG1_yhdG5Tix74meKlG_45_7C8x9ZJn8TF5MfDMMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/wishlist.vue?macro=true";
import { default as merch_45pdpTKJ9IDxN3DYXePCf3Urs97_45XjDfh5I7av8v_45kzo5C18Meta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/merch-pdp.vue?macro=true";
import { default as ropo_45basket23a36dOpJ5M5r9iAmv_45Kh7L4ZyFzUjyfuFHkEl8nPDMMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/ropo-basket.vue?macro=true";
import { default as usernkL_LUXag704COfw3my0f_TKQgB8HVopUw4JrALngIkMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/user.vue?macro=true";
import { default as _91_46_46_46category_93e2nWUA_45gfv4Y7OYIxZOnJ5x4SYpJmRGuWZq8TfNwbScMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/[...category].vue?macro=true";
import { default as indexqUKa_mhkEJOOrkQ324bvwqN_f4JpdcWxYCIyL3MDEAEMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/index.vue?macro=true";
import { default as glasses_45pdpAufNqoQIfGEaVskUmYLmB00S3ZK_45_45as52znWWYFoGNYMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/glasses-pdp.vue?macro=true";
import { default as rx_45glasses_45pdpsHyBolJJoysRsO5qqSvnwXDvXJAZcTWBAbZNy8zqsVUMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/rx-glasses-pdp.vue?macro=true";
import { default as contact_45lens_45pdpBrQ49CpNWJtLvmH0sMbB_YTzcv718MyYmF_45JtrSUOtkMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/contact-lens-pdp.vue?macro=true";
import { default as _91id_93Z4oFAHzcZjUonzjMCCiihs5cPNs_9_457n1QmwVZI0C9IMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/[id].vue?macro=true";
import { default as appointmentsBDic5u1dR34xem0thaZu5QF9VTk6uNSxCok7iHeJ4dkMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/appointments.vue?macro=true";
import { default as indexvwQNzO_7HxnoC293p_45CoL0bogvd9g9vd9Wwe_45QkNgMIMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/index.vue?macro=true";
import { default as cleaning_45fluid_45pdpfSvJhd3GleoFR_ZXX7U_qasXG4fRD7JjlRffKtoGey4Meta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/cleaning-fluid-pdp.vue?macro=true";
import { default as indexrRlR7A4YhsU0dIQXQi_nr2U4rkYxa6URz4uUZevtDs0Meta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/index.vue?macro=true";
import { default as auftragsstatus25xrOJiPsvY8Q5Hw_NNmgjCHA9Tzw3RLdQoo4eESnrEMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/auftragsstatus.vue?macro=true";
import { default as _91slug_93Dtve4UygMc9NtZzNcemGmDRbyyjEsMb7PKpsypsFCt4Meta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/overlays/[group]/[slug].vue?macro=true";
import { default as hearing_45aids_45merch_45pdpTUyuknhgHeF0Cu1je8MwHAL395suOdYnhnq7SwebMw0Meta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/hearing-aids-merch-pdp.vue?macro=true";
import { default as _91id_93EeIWSvKCB8uwsf70GhrSv7r0sAcQ7DFQ9JS4ar3j6c4Meta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/[id].vue?macro=true";
import { default as indexy6qui5kRJIfV4s_cdO4IMLRz0V_450CXT5t_45t5iOFgbDIMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/index.vue?macro=true";
import { default as _91id_93_5QYlLW12IcPieXF9PQMT9Y7x3u4_45FsAsHE3pzXoSbcMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/[id].vue?macro=true";
import { default as indexjqXbzXLIMAk_nFvrx1pvoAnBcMIhxZuY9cY7IDJFJPgMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/index.vue?macro=true";
import { default as _91id_93wf3DLQj1hXKymRRNLYKEq7aajInbp92vYHJEaPnvl5sMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/[city]/[id].vue?macro=true";
import { default as gebrauchsanweisungenXG5Uoi_oi6TolJO_45nNdotEzuzH3cL9TNzcH9fYDMr1EMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/gebrauchsanweisungen.vue?macro=true";
import { default as konformitaetserklaerungenfCLHlRszuNR3hFZX8WXAQJe5e6ruph8zF_45kbJZmYDyoMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/konformitaetserklaerungen.vue?macro=true";
import { default as _91city_93_nxqPu8Gh_45kaDIG9RQMb2Q30uXf4f55mKFK7ebrxNwkMeta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/stadt/[county]/[city].vue?macro=true";
import { default as subscription_45cancellationsbcaGWuTd1Bu0BLo_0UztD8BtWaL_45Wnctj4CEJnUJqS0Meta } from "/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/subscription/subscription-cancellations.vue?macro=true";
export default [
  {
    name: "index___de-at",
    path: "/",
    meta: indexda9eg5cyJoeRQ5OHmehC2AixU5jT5bMbtaFLXls5Y_45UMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/index.vue")
  },
  {
    name: "index___de-de",
    path: "/",
    meta: indexda9eg5cyJoeRQ5OHmehC2AixU5jT5bMbtaFLXls5Y_45UMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/index.vue")
  },
  {
    name: "index___cs-cz",
    path: "/",
    meta: indexda9eg5cyJoeRQ5OHmehC2AixU5jT5bMbtaFLXls5Y_45UMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/index.vue")
  },
  {
    name: "index___pl-pl",
    path: "/",
    meta: indexda9eg5cyJoeRQ5OHmehC2AixU5jT5bMbtaFLXls5Y_45UMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/index.vue")
  },
  {
    name: "index___de-ch",
    path: "/",
    meta: indexda9eg5cyJoeRQ5OHmehC2AixU5jT5bMbtaFLXls5Y_45UMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/index.vue")
  },
  {
    name: "index___fr-ch",
    path: "/",
    meta: indexda9eg5cyJoeRQ5OHmehC2AixU5jT5bMbtaFLXls5Y_45UMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/index.vue")
  },
  {
    name: "index___it-ch",
    path: "/",
    meta: indexda9eg5cyJoeRQ5OHmehC2AixU5jT5bMbtaFLXls5Y_45UMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/index.vue")
  },
  {
    name: "index___it-it",
    path: "/",
    meta: indexda9eg5cyJoeRQ5OHmehC2AixU5jT5bMbtaFLXls5Y_45UMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/index.vue")
  },
  {
    name: "index___de-it",
    path: "/",
    meta: indexda9eg5cyJoeRQ5OHmehC2AixU5jT5bMbtaFLXls5Y_45UMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/index.vue")
  },
  {
    name: "basket___de-at",
    path: "/basket/",
    meta: basketNCmkoKxBjnjGNY3hhrPjTI_45e_WNVlksfT70GhS81fM8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/basket.vue")
  },
  {
    name: "basket___de-de",
    path: "/basket/",
    meta: basketNCmkoKxBjnjGNY3hhrPjTI_45e_WNVlksfT70GhS81fM8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/basket.vue")
  },
  {
    name: "basket___cs-cz",
    path: "/basket/",
    meta: basketNCmkoKxBjnjGNY3hhrPjTI_45e_WNVlksfT70GhS81fM8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/basket.vue")
  },
  {
    name: "basket___pl-pl",
    path: "/basket/",
    meta: basketNCmkoKxBjnjGNY3hhrPjTI_45e_WNVlksfT70GhS81fM8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/basket.vue")
  },
  {
    name: "basket___de-ch",
    path: "/basket/",
    meta: basketNCmkoKxBjnjGNY3hhrPjTI_45e_WNVlksfT70GhS81fM8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/basket.vue")
  },
  {
    name: "basket___fr-ch",
    path: "/basket/",
    meta: basketNCmkoKxBjnjGNY3hhrPjTI_45e_WNVlksfT70GhS81fM8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/basket.vue")
  },
  {
    name: "basket___it-ch",
    path: "/basket/",
    meta: basketNCmkoKxBjnjGNY3hhrPjTI_45e_WNVlksfT70GhS81fM8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/basket.vue")
  },
  {
    name: "basket___it-it",
    path: "/basket/",
    meta: basketNCmkoKxBjnjGNY3hhrPjTI_45e_WNVlksfT70GhS81fM8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/basket.vue")
  },
  {
    name: "basket___de-it",
    path: "/basket/",
    meta: basketNCmkoKxBjnjGNY3hhrPjTI_45e_WNVlksfT70GhS81fM8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/basket.vue")
  },
  {
    name: "search___de-at",
    path: "/search/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/search.vue")
  },
  {
    name: "search___de-de",
    path: "/search/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/search.vue")
  },
  {
    name: "search___cs-cz",
    path: "/search/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/search.vue")
  },
  {
    name: "search___pl-pl",
    path: "/search/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/search.vue")
  },
  {
    name: "search___de-ch",
    path: "/search/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/search.vue")
  },
  {
    name: "search___fr-ch",
    path: "/search/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/search.vue")
  },
  {
    name: "search___it-ch",
    path: "/search/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/search.vue")
  },
  {
    name: "search___it-it",
    path: "/search/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/search.vue")
  },
  {
    name: "search___de-it",
    path: "/search/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/search.vue")
  },
  {
    name: "signin___de-at",
    path: "/signin/",
    meta: signinu06cCdb90ST91r3y2kEFluvvpwHfWawhBYTf2t2gHakMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/signin.vue")
  },
  {
    name: "signin___de-de",
    path: "/signin/",
    meta: signinu06cCdb90ST91r3y2kEFluvvpwHfWawhBYTf2t2gHakMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/signin.vue")
  },
  {
    name: "signin___cs-cz",
    path: "/signin/",
    meta: signinu06cCdb90ST91r3y2kEFluvvpwHfWawhBYTf2t2gHakMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/signin.vue")
  },
  {
    name: "signin___pl-pl",
    path: "/signin/",
    meta: signinu06cCdb90ST91r3y2kEFluvvpwHfWawhBYTf2t2gHakMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/signin.vue")
  },
  {
    name: "signin___de-ch",
    path: "/signin/",
    meta: signinu06cCdb90ST91r3y2kEFluvvpwHfWawhBYTf2t2gHakMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/signin.vue")
  },
  {
    name: "signin___fr-ch",
    path: "/signin/",
    meta: signinu06cCdb90ST91r3y2kEFluvvpwHfWawhBYTf2t2gHakMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/signin.vue")
  },
  {
    name: "signin___it-ch",
    path: "/signin/",
    meta: signinu06cCdb90ST91r3y2kEFluvvpwHfWawhBYTf2t2gHakMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/signin.vue")
  },
  {
    name: "signin___it-it",
    path: "/signin/",
    meta: signinu06cCdb90ST91r3y2kEFluvvpwHfWawhBYTf2t2gHakMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/signin.vue")
  },
  {
    name: "signin___de-it",
    path: "/signin/",
    meta: signinu06cCdb90ST91r3y2kEFluvvpwHfWawhBYTf2t2gHakMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/signin.vue")
  },
  {
    name: "success___de-at",
    path: "/success/",
    meta: successlky_45uOJxuwXTLFJ1l5Qf0ARq_23KuqxkbGZO0Kv4tuAMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/success.vue")
  },
  {
    name: "success___de-de",
    path: "/success/",
    meta: successlky_45uOJxuwXTLFJ1l5Qf0ARq_23KuqxkbGZO0Kv4tuAMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/success.vue")
  },
  {
    name: "success___cs-cz",
    path: "/success/",
    meta: successlky_45uOJxuwXTLFJ1l5Qf0ARq_23KuqxkbGZO0Kv4tuAMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/success.vue")
  },
  {
    name: "success___pl-pl",
    path: "/success/",
    meta: successlky_45uOJxuwXTLFJ1l5Qf0ARq_23KuqxkbGZO0Kv4tuAMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/success.vue")
  },
  {
    name: "success___de-ch",
    path: "/success/",
    meta: successlky_45uOJxuwXTLFJ1l5Qf0ARq_23KuqxkbGZO0Kv4tuAMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/success.vue")
  },
  {
    name: "success___fr-ch",
    path: "/success/",
    meta: successlky_45uOJxuwXTLFJ1l5Qf0ARq_23KuqxkbGZO0Kv4tuAMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/success.vue")
  },
  {
    name: "success___it-ch",
    path: "/success/",
    meta: successlky_45uOJxuwXTLFJ1l5Qf0ARq_23KuqxkbGZO0Kv4tuAMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/success.vue")
  },
  {
    name: "success___it-it",
    path: "/success/",
    meta: successlky_45uOJxuwXTLFJ1l5Qf0ARq_23KuqxkbGZO0Kv4tuAMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/success.vue")
  },
  {
    name: "success___de-it",
    path: "/success/",
    meta: successlky_45uOJxuwXTLFJ1l5Qf0ARq_23KuqxkbGZO0Kv4tuAMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/success.vue")
  },
  {
    name: "checkout___de-at",
    path: "/checkout/",
    meta: checkout6dybzrTSEjdfXBQ_o3bHJk2IEAT1_45LC8VcApf7CdHO8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/checkout.vue")
  },
  {
    name: "checkout___de-de",
    path: "/checkout/",
    meta: checkout6dybzrTSEjdfXBQ_o3bHJk2IEAT1_45LC8VcApf7CdHO8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/checkout.vue")
  },
  {
    name: "checkout___cs-cz",
    path: "/checkout/",
    meta: checkout6dybzrTSEjdfXBQ_o3bHJk2IEAT1_45LC8VcApf7CdHO8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/checkout.vue")
  },
  {
    name: "checkout___pl-pl",
    path: "/checkout/",
    meta: checkout6dybzrTSEjdfXBQ_o3bHJk2IEAT1_45LC8VcApf7CdHO8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/checkout.vue")
  },
  {
    name: "checkout___de-ch",
    path: "/checkout/",
    meta: checkout6dybzrTSEjdfXBQ_o3bHJk2IEAT1_45LC8VcApf7CdHO8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/checkout.vue")
  },
  {
    name: "checkout___fr-ch",
    path: "/checkout/",
    meta: checkout6dybzrTSEjdfXBQ_o3bHJk2IEAT1_45LC8VcApf7CdHO8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/checkout.vue")
  },
  {
    name: "checkout___it-ch",
    path: "/checkout/",
    meta: checkout6dybzrTSEjdfXBQ_o3bHJk2IEAT1_45LC8VcApf7CdHO8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/checkout.vue")
  },
  {
    name: "checkout___it-it",
    path: "/checkout/",
    meta: checkout6dybzrTSEjdfXBQ_o3bHJk2IEAT1_45LC8VcApf7CdHO8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/checkout.vue")
  },
  {
    name: "checkout___de-it",
    path: "/checkout/",
    meta: checkout6dybzrTSEjdfXBQ_o3bHJk2IEAT1_45LC8VcApf7CdHO8Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/checkout.vue")
  },
  {
    name: "p-slug___de-at",
    path: "/p/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/[slug].vue")
  },
  {
    name: "p-slug___de-de",
    path: "/p/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/[slug].vue")
  },
  {
    name: "p-slug___cs-cz",
    path: "/p/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/[slug].vue")
  },
  {
    name: "p-slug___pl-pl",
    path: "/p/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/[slug].vue")
  },
  {
    name: "p-slug___de-ch",
    path: "/p/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/[slug].vue")
  },
  {
    name: "p-slug___fr-ch",
    path: "/p/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/[slug].vue")
  },
  {
    name: "p-slug___it-ch",
    path: "/p/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/[slug].vue")
  },
  {
    name: "p-slug___it-it",
    path: "/p/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/[slug].vue")
  },
  {
    name: "p-slug___de-it",
    path: "/p/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/[slug].vue")
  },
  {
    name: "ropo-plp___de-at",
    path: "/anprobevorort/",
    meta: ropo_45plpsGoF5kq0h5tASimbd6xQAvCjhjMb9lhXHYzSjuQavA4Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/ropo-plp.vue")
  },
  {
    name: "ropo-plp___de-de",
    path: "/anprobevorort/",
    meta: ropo_45plpsGoF5kq0h5tASimbd6xQAvCjhjMb9lhXHYzSjuQavA4Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/ropo-plp.vue")
  },
  {
    name: "ropo-plp___it-it",
    path: "/anprobevorort/",
    meta: ropo_45plpsGoF5kq0h5tASimbd6xQAvCjhjMb9lhXHYzSjuQavA4Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/ropo-plp.vue")
  },
  {
    name: "ropo-plp___de-it",
    path: "/anprobevorort/",
    meta: ropo_45plpsGoF5kq0h5tASimbd6xQAvCjhjMb9lhXHYzSjuQavA4Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/ropo-plp.vue")
  },
  {
    name: "wishlist___de-at",
    path: "/wishlist/",
    meta: wishlistzgG4XUGG1_yhdG5Tix74meKlG_45_7C8x9ZJn8TF5MfDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/wishlist.vue")
  },
  {
    name: "wishlist___de-de",
    path: "/wishlist/",
    meta: wishlistzgG4XUGG1_yhdG5Tix74meKlG_45_7C8x9ZJn8TF5MfDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/wishlist.vue")
  },
  {
    name: "wishlist___cs-cz",
    path: "/wishlist/",
    meta: wishlistzgG4XUGG1_yhdG5Tix74meKlG_45_7C8x9ZJn8TF5MfDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/wishlist.vue")
  },
  {
    name: "wishlist___pl-pl",
    path: "/wishlist/",
    meta: wishlistzgG4XUGG1_yhdG5Tix74meKlG_45_7C8x9ZJn8TF5MfDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/wishlist.vue")
  },
  {
    name: "wishlist___de-ch",
    path: "/wishlist/",
    meta: wishlistzgG4XUGG1_yhdG5Tix74meKlG_45_7C8x9ZJn8TF5MfDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/wishlist.vue")
  },
  {
    name: "wishlist___fr-ch",
    path: "/wishlist/",
    meta: wishlistzgG4XUGG1_yhdG5Tix74meKlG_45_7C8x9ZJn8TF5MfDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/wishlist.vue")
  },
  {
    name: "wishlist___it-ch",
    path: "/wishlist/",
    meta: wishlistzgG4XUGG1_yhdG5Tix74meKlG_45_7C8x9ZJn8TF5MfDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/wishlist.vue")
  },
  {
    name: "wishlist___it-it",
    path: "/wishlist/",
    meta: wishlistzgG4XUGG1_yhdG5Tix74meKlG_45_7C8x9ZJn8TF5MfDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/wishlist.vue")
  },
  {
    name: "wishlist___de-it",
    path: "/wishlist/",
    meta: wishlistzgG4XUGG1_yhdG5Tix74meKlG_45_7C8x9ZJn8TF5MfDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/wishlist.vue")
  },
  {
    name: "p-merch-pdp___de-at",
    path: "/p/merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/merch-pdp.vue")
  },
  {
    name: "p-merch-pdp___de-de",
    path: "/p/merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/merch-pdp.vue")
  },
  {
    name: "p-merch-pdp___cs-cz",
    path: "/p/merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/merch-pdp.vue")
  },
  {
    name: "p-merch-pdp___pl-pl",
    path: "/p/merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/merch-pdp.vue")
  },
  {
    name: "p-merch-pdp___de-ch",
    path: "/p/merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/merch-pdp.vue")
  },
  {
    name: "p-merch-pdp___fr-ch",
    path: "/p/merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/merch-pdp.vue")
  },
  {
    name: "p-merch-pdp___it-ch",
    path: "/p/merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/merch-pdp.vue")
  },
  {
    name: "p-merch-pdp___it-it",
    path: "/p/merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/merch-pdp.vue")
  },
  {
    name: "p-merch-pdp___de-it",
    path: "/p/merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/merch-pdp.vue")
  },
  {
    name: "ropo-basket___de-at",
    path: "/anprobeliste/",
    meta: ropo_45basket23a36dOpJ5M5r9iAmv_45Kh7L4ZyFzUjyfuFHkEl8nPDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/ropo-basket.vue")
  },
  {
    name: "ropo-basket___de-de",
    path: "/anprobeliste/",
    meta: ropo_45basket23a36dOpJ5M5r9iAmv_45Kh7L4ZyFzUjyfuFHkEl8nPDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/ropo-basket.vue")
  },
  {
    name: "ropo-basket___it-it",
    path: "/anprobeliste/",
    meta: ropo_45basket23a36dOpJ5M5r9iAmv_45Kh7L4ZyFzUjyfuFHkEl8nPDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/ropo-basket.vue")
  },
  {
    name: "ropo-basket___de-it",
    path: "/anprobeliste/",
    meta: ropo_45basket23a36dOpJ5M5r9iAmv_45Kh7L4ZyFzUjyfuFHkEl8nPDMMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/ropo-basket.vue")
  },
  {
    name: "account-user___de-at",
    path: "/account/user/",
    meta: usernkL_LUXag704COfw3my0f_TKQgB8HVopUw4JrALngIkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/user.vue")
  },
  {
    name: "account-user___de-de",
    path: "/account/user/",
    meta: usernkL_LUXag704COfw3my0f_TKQgB8HVopUw4JrALngIkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/user.vue")
  },
  {
    name: "account-user___cs-cz",
    path: "/account/user/",
    meta: usernkL_LUXag704COfw3my0f_TKQgB8HVopUw4JrALngIkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/user.vue")
  },
  {
    name: "account-user___pl-pl",
    path: "/account/user/",
    meta: usernkL_LUXag704COfw3my0f_TKQgB8HVopUw4JrALngIkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/user.vue")
  },
  {
    name: "account-user___de-ch",
    path: "/account/user/",
    meta: usernkL_LUXag704COfw3my0f_TKQgB8HVopUw4JrALngIkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/user.vue")
  },
  {
    name: "account-user___fr-ch",
    path: "/account/user/",
    meta: usernkL_LUXag704COfw3my0f_TKQgB8HVopUw4JrALngIkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/user.vue")
  },
  {
    name: "account-user___it-ch",
    path: "/account/user/",
    meta: usernkL_LUXag704COfw3my0f_TKQgB8HVopUw4JrALngIkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/user.vue")
  },
  {
    name: "account-user___it-it",
    path: "/account/user/",
    meta: usernkL_LUXag704COfw3my0f_TKQgB8HVopUw4JrALngIkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/user.vue")
  },
  {
    name: "account-user___de-it",
    path: "/account/user/",
    meta: usernkL_LUXag704COfw3my0f_TKQgB8HVopUw4JrALngIkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/user.vue")
  },
  {
    name: "category___de-at",
    path: "/:category(.*)*/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/[...category].vue")
  },
  {
    name: "category___de-de",
    path: "/:category(.*)*/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/[...category].vue")
  },
  {
    name: "category___cs-cz",
    path: "/:category(.*)*/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/[...category].vue")
  },
  {
    name: "category___pl-pl",
    path: "/:category(.*)*/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/[...category].vue")
  },
  {
    name: "category___de-ch",
    path: "/:category(.*)*/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/[...category].vue")
  },
  {
    name: "category___fr-ch",
    path: "/:category(.*)*/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/[...category].vue")
  },
  {
    name: "category___it-ch",
    path: "/:category(.*)*/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/[...category].vue")
  },
  {
    name: "category___it-it",
    path: "/:category(.*)*/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/[...category].vue")
  },
  {
    name: "category___de-it",
    path: "/:category(.*)*/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/[...category].vue")
  },
  {
    name: "account___de-at",
    path: "/account/",
    meta: indexqUKa_mhkEJOOrkQ324bvwqN_f4JpdcWxYCIyL3MDEAEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/index.vue")
  },
  {
    name: "account___de-de",
    path: "/account/",
    meta: indexqUKa_mhkEJOOrkQ324bvwqN_f4JpdcWxYCIyL3MDEAEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/index.vue")
  },
  {
    name: "account___cs-cz",
    path: "/account/",
    meta: indexqUKa_mhkEJOOrkQ324bvwqN_f4JpdcWxYCIyL3MDEAEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/index.vue")
  },
  {
    name: "account___pl-pl",
    path: "/account/",
    meta: indexqUKa_mhkEJOOrkQ324bvwqN_f4JpdcWxYCIyL3MDEAEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/index.vue")
  },
  {
    name: "account___de-ch",
    path: "/account/",
    meta: indexqUKa_mhkEJOOrkQ324bvwqN_f4JpdcWxYCIyL3MDEAEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/index.vue")
  },
  {
    name: "account___fr-ch",
    path: "/account/",
    meta: indexqUKa_mhkEJOOrkQ324bvwqN_f4JpdcWxYCIyL3MDEAEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/index.vue")
  },
  {
    name: "account___it-ch",
    path: "/account/",
    meta: indexqUKa_mhkEJOOrkQ324bvwqN_f4JpdcWxYCIyL3MDEAEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/index.vue")
  },
  {
    name: "account___it-it",
    path: "/account/",
    meta: indexqUKa_mhkEJOOrkQ324bvwqN_f4JpdcWxYCIyL3MDEAEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/index.vue")
  },
  {
    name: "account___de-it",
    path: "/account/",
    meta: indexqUKa_mhkEJOOrkQ324bvwqN_f4JpdcWxYCIyL3MDEAEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/index.vue")
  },
  {
    name: "p-glasses-pdp___de-at",
    path: "/p/glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/glasses-pdp.vue")
  },
  {
    name: "p-glasses-pdp___de-de",
    path: "/p/glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/glasses-pdp.vue")
  },
  {
    name: "p-glasses-pdp___cs-cz",
    path: "/p/glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/glasses-pdp.vue")
  },
  {
    name: "p-glasses-pdp___pl-pl",
    path: "/p/glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/glasses-pdp.vue")
  },
  {
    name: "p-glasses-pdp___de-ch",
    path: "/p/glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/glasses-pdp.vue")
  },
  {
    name: "p-glasses-pdp___fr-ch",
    path: "/p/glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/glasses-pdp.vue")
  },
  {
    name: "p-glasses-pdp___it-ch",
    path: "/p/glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/glasses-pdp.vue")
  },
  {
    name: "p-glasses-pdp___it-it",
    path: "/p/glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/glasses-pdp.vue")
  },
  {
    name: "p-glasses-pdp___de-it",
    path: "/p/glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/glasses-pdp.vue")
  },
  {
    name: "p-rx-glasses-pdp___de-at",
    path: "/p/rx-glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/rx-glasses-pdp.vue")
  },
  {
    name: "p-rx-glasses-pdp___de-de",
    path: "/p/rx-glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/rx-glasses-pdp.vue")
  },
  {
    name: "p-rx-glasses-pdp___cs-cz",
    path: "/p/rx-glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/rx-glasses-pdp.vue")
  },
  {
    name: "p-rx-glasses-pdp___pl-pl",
    path: "/p/rx-glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/rx-glasses-pdp.vue")
  },
  {
    name: "p-rx-glasses-pdp___de-ch",
    path: "/p/rx-glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/rx-glasses-pdp.vue")
  },
  {
    name: "p-rx-glasses-pdp___fr-ch",
    path: "/p/rx-glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/rx-glasses-pdp.vue")
  },
  {
    name: "p-rx-glasses-pdp___it-ch",
    path: "/p/rx-glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/rx-glasses-pdp.vue")
  },
  {
    name: "p-rx-glasses-pdp___it-it",
    path: "/p/rx-glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/rx-glasses-pdp.vue")
  },
  {
    name: "p-rx-glasses-pdp___de-it",
    path: "/p/rx-glasses-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/rx-glasses-pdp.vue")
  },
  {
    name: "p-contact-lens-pdp___de-at",
    path: "/p/contact-lens-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/contact-lens-pdp.vue")
  },
  {
    name: "p-contact-lens-pdp___de-de",
    path: "/p/contact-lens-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/contact-lens-pdp.vue")
  },
  {
    name: "p-contact-lens-pdp___cs-cz",
    path: "/p/contact-lens-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/contact-lens-pdp.vue")
  },
  {
    name: "p-contact-lens-pdp___pl-pl",
    path: "/p/contact-lens-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/contact-lens-pdp.vue")
  },
  {
    name: "p-contact-lens-pdp___de-ch",
    path: "/p/contact-lens-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/contact-lens-pdp.vue")
  },
  {
    name: "p-contact-lens-pdp___fr-ch",
    path: "/p/contact-lens-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/contact-lens-pdp.vue")
  },
  {
    name: "p-contact-lens-pdp___it-ch",
    path: "/p/contact-lens-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/contact-lens-pdp.vue")
  },
  {
    name: "p-contact-lens-pdp___it-it",
    path: "/p/contact-lens-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/contact-lens-pdp.vue")
  },
  {
    name: "p-contact-lens-pdp___de-it",
    path: "/p/contact-lens-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/contact-lens-pdp.vue")
  },
  {
    name: "account-orders-id___de-at",
    path: "/account/orders/:id()/",
    meta: _91id_93Z4oFAHzcZjUonzjMCCiihs5cPNs_9_457n1QmwVZI0C9IMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders-id___de-de",
    path: "/account/orders/:id()/",
    meta: _91id_93Z4oFAHzcZjUonzjMCCiihs5cPNs_9_457n1QmwVZI0C9IMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders-id___cs-cz",
    path: "/account/orders/:id()/",
    meta: _91id_93Z4oFAHzcZjUonzjMCCiihs5cPNs_9_457n1QmwVZI0C9IMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders-id___pl-pl",
    path: "/account/orders/:id()/",
    meta: _91id_93Z4oFAHzcZjUonzjMCCiihs5cPNs_9_457n1QmwVZI0C9IMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders-id___de-ch",
    path: "/account/orders/:id()/",
    meta: _91id_93Z4oFAHzcZjUonzjMCCiihs5cPNs_9_457n1QmwVZI0C9IMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders-id___fr-ch",
    path: "/account/orders/:id()/",
    meta: _91id_93Z4oFAHzcZjUonzjMCCiihs5cPNs_9_457n1QmwVZI0C9IMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders-id___it-ch",
    path: "/account/orders/:id()/",
    meta: _91id_93Z4oFAHzcZjUonzjMCCiihs5cPNs_9_457n1QmwVZI0C9IMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders-id___it-it",
    path: "/account/orders/:id()/",
    meta: _91id_93Z4oFAHzcZjUonzjMCCiihs5cPNs_9_457n1QmwVZI0C9IMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders-id___de-it",
    path: "/account/orders/:id()/",
    meta: _91id_93Z4oFAHzcZjUonzjMCCiihs5cPNs_9_457n1QmwVZI0C9IMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/[id].vue")
  },
  {
    name: "account-appointments___de-at",
    path: "/account/appointments/",
    meta: appointmentsBDic5u1dR34xem0thaZu5QF9VTk6uNSxCok7iHeJ4dkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/appointments.vue")
  },
  {
    name: "account-appointments___de-de",
    path: "/account/appointments/",
    meta: appointmentsBDic5u1dR34xem0thaZu5QF9VTk6uNSxCok7iHeJ4dkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/appointments.vue")
  },
  {
    name: "account-appointments___cs-cz",
    path: "/account/appointments/",
    meta: appointmentsBDic5u1dR34xem0thaZu5QF9VTk6uNSxCok7iHeJ4dkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/appointments.vue")
  },
  {
    name: "account-appointments___pl-pl",
    path: "/account/appointments/",
    meta: appointmentsBDic5u1dR34xem0thaZu5QF9VTk6uNSxCok7iHeJ4dkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/appointments.vue")
  },
  {
    name: "account-appointments___de-ch",
    path: "/account/appointments/",
    meta: appointmentsBDic5u1dR34xem0thaZu5QF9VTk6uNSxCok7iHeJ4dkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/appointments.vue")
  },
  {
    name: "account-appointments___fr-ch",
    path: "/account/appointments/",
    meta: appointmentsBDic5u1dR34xem0thaZu5QF9VTk6uNSxCok7iHeJ4dkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/appointments.vue")
  },
  {
    name: "account-appointments___it-ch",
    path: "/account/appointments/",
    meta: appointmentsBDic5u1dR34xem0thaZu5QF9VTk6uNSxCok7iHeJ4dkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/appointments.vue")
  },
  {
    name: "account-appointments___it-it",
    path: "/account/appointments/",
    meta: appointmentsBDic5u1dR34xem0thaZu5QF9VTk6uNSxCok7iHeJ4dkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/appointments.vue")
  },
  {
    name: "account-appointments___de-it",
    path: "/account/appointments/",
    meta: appointmentsBDic5u1dR34xem0thaZu5QF9VTk6uNSxCok7iHeJ4dkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/appointments.vue")
  },
  {
    name: "account-orders___de-at",
    path: "/account/orders/",
    meta: indexvwQNzO_7HxnoC293p_45CoL0bogvd9g9vd9Wwe_45QkNgMIMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___de-de",
    path: "/account/orders/",
    meta: indexvwQNzO_7HxnoC293p_45CoL0bogvd9g9vd9Wwe_45QkNgMIMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___cs-cz",
    path: "/account/orders/",
    meta: indexvwQNzO_7HxnoC293p_45CoL0bogvd9g9vd9Wwe_45QkNgMIMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___pl-pl",
    path: "/account/orders/",
    meta: indexvwQNzO_7HxnoC293p_45CoL0bogvd9g9vd9Wwe_45QkNgMIMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___de-ch",
    path: "/account/orders/",
    meta: indexvwQNzO_7HxnoC293p_45CoL0bogvd9g9vd9Wwe_45QkNgMIMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___fr-ch",
    path: "/account/orders/",
    meta: indexvwQNzO_7HxnoC293p_45CoL0bogvd9g9vd9Wwe_45QkNgMIMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___it-ch",
    path: "/account/orders/",
    meta: indexvwQNzO_7HxnoC293p_45CoL0bogvd9g9vd9Wwe_45QkNgMIMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___it-it",
    path: "/account/orders/",
    meta: indexvwQNzO_7HxnoC293p_45CoL0bogvd9g9vd9Wwe_45QkNgMIMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___de-it",
    path: "/account/orders/",
    meta: indexvwQNzO_7HxnoC293p_45CoL0bogvd9g9vd9Wwe_45QkNgMIMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/orders/index.vue")
  },
  {
    name: "p-cleaning-fluid-pdp___de-at",
    path: "/p/cleaning-fluid-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/cleaning-fluid-pdp.vue")
  },
  {
    name: "p-cleaning-fluid-pdp___de-de",
    path: "/p/cleaning-fluid-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/cleaning-fluid-pdp.vue")
  },
  {
    name: "p-cleaning-fluid-pdp___cs-cz",
    path: "/p/cleaning-fluid-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/cleaning-fluid-pdp.vue")
  },
  {
    name: "p-cleaning-fluid-pdp___pl-pl",
    path: "/p/cleaning-fluid-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/cleaning-fluid-pdp.vue")
  },
  {
    name: "p-cleaning-fluid-pdp___de-ch",
    path: "/p/cleaning-fluid-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/cleaning-fluid-pdp.vue")
  },
  {
    name: "p-cleaning-fluid-pdp___fr-ch",
    path: "/p/cleaning-fluid-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/cleaning-fluid-pdp.vue")
  },
  {
    name: "p-cleaning-fluid-pdp___it-ch",
    path: "/p/cleaning-fluid-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/cleaning-fluid-pdp.vue")
  },
  {
    name: "p-cleaning-fluid-pdp___it-it",
    path: "/p/cleaning-fluid-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/cleaning-fluid-pdp.vue")
  },
  {
    name: "p-cleaning-fluid-pdp___de-it",
    path: "/p/cleaning-fluid-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/cleaning-fluid-pdp.vue")
  },
  {
    name: "niederlassungen___de-at",
    path: "/niederlassungen/",
    meta: indexrRlR7A4YhsU0dIQXQi_nr2U4rkYxa6URz4uUZevtDs0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/index.vue")
  },
  {
    name: "niederlassungen___de-de",
    path: "/niederlassungen/",
    meta: indexrRlR7A4YhsU0dIQXQi_nr2U4rkYxa6URz4uUZevtDs0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/index.vue")
  },
  {
    name: "niederlassungen___cs-cz",
    path: "/pobocky/",
    meta: indexrRlR7A4YhsU0dIQXQi_nr2U4rkYxa6URz4uUZevtDs0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/index.vue")
  },
  {
    name: "niederlassungen___pl-pl",
    path: "/salony/",
    meta: indexrRlR7A4YhsU0dIQXQi_nr2U4rkYxa6URz4uUZevtDs0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/index.vue")
  },
  {
    name: "niederlassungen___de-ch",
    path: "/niederlassungen/",
    meta: indexrRlR7A4YhsU0dIQXQi_nr2U4rkYxa6URz4uUZevtDs0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/index.vue")
  },
  {
    name: "niederlassungen___fr-ch",
    path: "/succursales/",
    meta: indexrRlR7A4YhsU0dIQXQi_nr2U4rkYxa6URz4uUZevtDs0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/index.vue")
  },
  {
    name: "niederlassungen___it-ch",
    path: "/filiali/",
    meta: indexrRlR7A4YhsU0dIQXQi_nr2U4rkYxa6URz4uUZevtDs0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/index.vue")
  },
  {
    name: "niederlassungen___it-it",
    path: "/niederlassungen/",
    meta: indexrRlR7A4YhsU0dIQXQi_nr2U4rkYxa6URz4uUZevtDs0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/index.vue")
  },
  {
    name: "niederlassungen___de-it",
    path: "/niederlassungen/",
    meta: indexrRlR7A4YhsU0dIQXQi_nr2U4rkYxa6URz4uUZevtDs0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/index.vue")
  },
  {
    name: "service-auftragsstatus___de-at",
    path: "/service/auftragsstatus/",
    meta: auftragsstatus25xrOJiPsvY8Q5Hw_NNmgjCHA9Tzw3RLdQoo4eESnrEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/auftragsstatus.vue")
  },
  {
    name: "service-auftragsstatus___de-de",
    path: "/service/auftragsstatus/",
    meta: auftragsstatus25xrOJiPsvY8Q5Hw_NNmgjCHA9Tzw3RLdQoo4eESnrEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/auftragsstatus.vue")
  },
  {
    name: "service-auftragsstatus___pl-pl",
    path: "/uslugi/status/",
    meta: auftragsstatus25xrOJiPsvY8Q5Hw_NNmgjCHA9Tzw3RLdQoo4eESnrEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/auftragsstatus.vue")
  },
  {
    name: "service-auftragsstatus___de-ch",
    path: "/service/auftragsstatus/",
    meta: auftragsstatus25xrOJiPsvY8Q5Hw_NNmgjCHA9Tzw3RLdQoo4eESnrEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/auftragsstatus.vue")
  },
  {
    name: "service-auftragsstatus___fr-ch",
    path: "/service/statut/",
    meta: auftragsstatus25xrOJiPsvY8Q5Hw_NNmgjCHA9Tzw3RLdQoo4eESnrEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/auftragsstatus.vue")
  },
  {
    name: "service-auftragsstatus___it-ch",
    path: "/servizi/stato/",
    meta: auftragsstatus25xrOJiPsvY8Q5Hw_NNmgjCHA9Tzw3RLdQoo4eESnrEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/auftragsstatus.vue")
  },
  {
    name: "service-auftragsstatus___it-it",
    path: "/service/auftragsstatus/",
    meta: auftragsstatus25xrOJiPsvY8Q5Hw_NNmgjCHA9Tzw3RLdQoo4eESnrEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/auftragsstatus.vue")
  },
  {
    name: "service-auftragsstatus___de-it",
    path: "/service/auftragsstatus/",
    meta: auftragsstatus25xrOJiPsvY8Q5Hw_NNmgjCHA9Tzw3RLdQoo4eESnrEMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/auftragsstatus.vue")
  },
  {
    name: "overlays-group-slug___de-at",
    path: "/overlays/:group()/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/overlays/[group]/[slug].vue")
  },
  {
    name: "overlays-group-slug___de-de",
    path: "/overlays/:group()/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/overlays/[group]/[slug].vue")
  },
  {
    name: "overlays-group-slug___cs-cz",
    path: "/overlays/:group()/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/overlays/[group]/[slug].vue")
  },
  {
    name: "overlays-group-slug___pl-pl",
    path: "/overlays/:group()/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/overlays/[group]/[slug].vue")
  },
  {
    name: "overlays-group-slug___de-ch",
    path: "/overlays/:group()/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/overlays/[group]/[slug].vue")
  },
  {
    name: "overlays-group-slug___fr-ch",
    path: "/overlays/:group()/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/overlays/[group]/[slug].vue")
  },
  {
    name: "overlays-group-slug___it-ch",
    path: "/overlays/:group()/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/overlays/[group]/[slug].vue")
  },
  {
    name: "overlays-group-slug___it-it",
    path: "/overlays/:group()/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/overlays/[group]/[slug].vue")
  },
  {
    name: "overlays-group-slug___de-it",
    path: "/overlays/:group()/:slug()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/overlays/[group]/[slug].vue")
  },
  {
    name: "p-hearing-aids-merch-pdp___de-at",
    path: "/p/hearing-aids-merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/hearing-aids-merch-pdp.vue")
  },
  {
    name: "p-hearing-aids-merch-pdp___de-de",
    path: "/p/hearing-aids-merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/hearing-aids-merch-pdp.vue")
  },
  {
    name: "p-hearing-aids-merch-pdp___cs-cz",
    path: "/p/hearing-aids-merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/hearing-aids-merch-pdp.vue")
  },
  {
    name: "p-hearing-aids-merch-pdp___pl-pl",
    path: "/p/hearing-aids-merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/hearing-aids-merch-pdp.vue")
  },
  {
    name: "p-hearing-aids-merch-pdp___de-ch",
    path: "/p/hearing-aids-merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/hearing-aids-merch-pdp.vue")
  },
  {
    name: "p-hearing-aids-merch-pdp___fr-ch",
    path: "/p/hearing-aids-merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/hearing-aids-merch-pdp.vue")
  },
  {
    name: "p-hearing-aids-merch-pdp___it-ch",
    path: "/p/hearing-aids-merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/hearing-aids-merch-pdp.vue")
  },
  {
    name: "p-hearing-aids-merch-pdp___it-it",
    path: "/p/hearing-aids-merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/hearing-aids-merch-pdp.vue")
  },
  {
    name: "p-hearing-aids-merch-pdp___de-it",
    path: "/p/hearing-aids-merch-pdp/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/p/hearing-aids-merch-pdp.vue")
  },
  {
    name: "account-branch-order-id___de-at",
    path: "/account/branch-order/:id()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/[id].vue")
  },
  {
    name: "account-branch-order-id___de-de",
    path: "/account/branch-order/:id()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/[id].vue")
  },
  {
    name: "account-branch-order-id___cs-cz",
    path: "/account/branch-order/:id()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/[id].vue")
  },
  {
    name: "account-branch-order-id___pl-pl",
    path: "/account/branch-order/:id()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/[id].vue")
  },
  {
    name: "account-branch-order-id___de-ch",
    path: "/account/branch-order/:id()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/[id].vue")
  },
  {
    name: "account-branch-order-id___fr-ch",
    path: "/account/branch-order/:id()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/[id].vue")
  },
  {
    name: "account-branch-order-id___it-ch",
    path: "/account/branch-order/:id()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/[id].vue")
  },
  {
    name: "account-branch-order-id___it-it",
    path: "/account/branch-order/:id()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/[id].vue")
  },
  {
    name: "account-branch-order-id___de-it",
    path: "/account/branch-order/:id()/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/[id].vue")
  },
  {
    name: "account-branch-order___de-at",
    path: "/account/branch-order/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/index.vue")
  },
  {
    name: "account-branch-order___de-de",
    path: "/account/branch-order/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/index.vue")
  },
  {
    name: "account-branch-order___cs-cz",
    path: "/account/branch-order/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/index.vue")
  },
  {
    name: "account-branch-order___pl-pl",
    path: "/account/branch-order/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/index.vue")
  },
  {
    name: "account-branch-order___de-ch",
    path: "/account/branch-order/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/index.vue")
  },
  {
    name: "account-branch-order___fr-ch",
    path: "/account/branch-order/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/index.vue")
  },
  {
    name: "account-branch-order___it-ch",
    path: "/account/branch-order/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/index.vue")
  },
  {
    name: "account-branch-order___it-it",
    path: "/account/branch-order/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/index.vue")
  },
  {
    name: "account-branch-order___de-it",
    path: "/account/branch-order/",
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/branch-order/index.vue")
  },
  {
    name: "account-subscriptions-id___de-at",
    path: "/account/subscriptions/:id()/",
    meta: _91id_93_5QYlLW12IcPieXF9PQMT9Y7x3u4_45FsAsHE3pzXoSbcMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/[id].vue")
  },
  {
    name: "account-subscriptions-id___de-de",
    path: "/account/subscriptions/:id()/",
    meta: _91id_93_5QYlLW12IcPieXF9PQMT9Y7x3u4_45FsAsHE3pzXoSbcMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/[id].vue")
  },
  {
    name: "account-subscriptions-id___cs-cz",
    path: "/account/subscriptions/:id()/",
    meta: _91id_93_5QYlLW12IcPieXF9PQMT9Y7x3u4_45FsAsHE3pzXoSbcMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/[id].vue")
  },
  {
    name: "account-subscriptions-id___pl-pl",
    path: "/account/subscriptions/:id()/",
    meta: _91id_93_5QYlLW12IcPieXF9PQMT9Y7x3u4_45FsAsHE3pzXoSbcMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/[id].vue")
  },
  {
    name: "account-subscriptions-id___de-ch",
    path: "/account/subscriptions/:id()/",
    meta: _91id_93_5QYlLW12IcPieXF9PQMT9Y7x3u4_45FsAsHE3pzXoSbcMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/[id].vue")
  },
  {
    name: "account-subscriptions-id___fr-ch",
    path: "/account/subscriptions/:id()/",
    meta: _91id_93_5QYlLW12IcPieXF9PQMT9Y7x3u4_45FsAsHE3pzXoSbcMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/[id].vue")
  },
  {
    name: "account-subscriptions-id___it-ch",
    path: "/account/subscriptions/:id()/",
    meta: _91id_93_5QYlLW12IcPieXF9PQMT9Y7x3u4_45FsAsHE3pzXoSbcMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/[id].vue")
  },
  {
    name: "account-subscriptions-id___it-it",
    path: "/account/subscriptions/:id()/",
    meta: _91id_93_5QYlLW12IcPieXF9PQMT9Y7x3u4_45FsAsHE3pzXoSbcMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/[id].vue")
  },
  {
    name: "account-subscriptions-id___de-it",
    path: "/account/subscriptions/:id()/",
    meta: _91id_93_5QYlLW12IcPieXF9PQMT9Y7x3u4_45FsAsHE3pzXoSbcMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/[id].vue")
  },
  {
    name: "account-subscriptions___de-at",
    path: "/account/subscriptions/",
    meta: indexjqXbzXLIMAk_nFvrx1pvoAnBcMIhxZuY9cY7IDJFJPgMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/index.vue")
  },
  {
    name: "account-subscriptions___de-de",
    path: "/account/subscriptions/",
    meta: indexjqXbzXLIMAk_nFvrx1pvoAnBcMIhxZuY9cY7IDJFJPgMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/index.vue")
  },
  {
    name: "account-subscriptions___cs-cz",
    path: "/account/subscriptions/",
    meta: indexjqXbzXLIMAk_nFvrx1pvoAnBcMIhxZuY9cY7IDJFJPgMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/index.vue")
  },
  {
    name: "account-subscriptions___pl-pl",
    path: "/account/subscriptions/",
    meta: indexjqXbzXLIMAk_nFvrx1pvoAnBcMIhxZuY9cY7IDJFJPgMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/index.vue")
  },
  {
    name: "account-subscriptions___de-ch",
    path: "/account/subscriptions/",
    meta: indexjqXbzXLIMAk_nFvrx1pvoAnBcMIhxZuY9cY7IDJFJPgMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/index.vue")
  },
  {
    name: "account-subscriptions___fr-ch",
    path: "/account/subscriptions/",
    meta: indexjqXbzXLIMAk_nFvrx1pvoAnBcMIhxZuY9cY7IDJFJPgMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/index.vue")
  },
  {
    name: "account-subscriptions___it-ch",
    path: "/account/subscriptions/",
    meta: indexjqXbzXLIMAk_nFvrx1pvoAnBcMIhxZuY9cY7IDJFJPgMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/index.vue")
  },
  {
    name: "account-subscriptions___it-it",
    path: "/account/subscriptions/",
    meta: indexjqXbzXLIMAk_nFvrx1pvoAnBcMIhxZuY9cY7IDJFJPgMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/index.vue")
  },
  {
    name: "account-subscriptions___de-it",
    path: "/account/subscriptions/",
    meta: indexjqXbzXLIMAk_nFvrx1pvoAnBcMIhxZuY9cY7IDJFJPgMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/account/subscriptions/index.vue")
  },
  {
    name: "niederlassungen-city-id___de-at",
    path: "/niederlassungen/:city()/:id()/",
    meta: _91id_93wf3DLQj1hXKymRRNLYKEq7aajInbp92vYHJEaPnvl5sMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/[city]/[id].vue")
  },
  {
    name: "niederlassungen-city-id___de-de",
    path: "/niederlassungen/:city()/:id()/",
    meta: _91id_93wf3DLQj1hXKymRRNLYKEq7aajInbp92vYHJEaPnvl5sMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/[city]/[id].vue")
  },
  {
    name: "niederlassungen-city-id___cs-cz",
    path: "/pobocky/:city()/:id()/",
    meta: _91id_93wf3DLQj1hXKymRRNLYKEq7aajInbp92vYHJEaPnvl5sMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/[city]/[id].vue")
  },
  {
    name: "niederlassungen-city-id___pl-pl",
    path: "/salony/:city()/:id()/",
    meta: _91id_93wf3DLQj1hXKymRRNLYKEq7aajInbp92vYHJEaPnvl5sMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/[city]/[id].vue")
  },
  {
    name: "niederlassungen-city-id___de-ch",
    path: "/niederlassungen/:city()/:id()/",
    meta: _91id_93wf3DLQj1hXKymRRNLYKEq7aajInbp92vYHJEaPnvl5sMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/[city]/[id].vue")
  },
  {
    name: "niederlassungen-city-id___fr-ch",
    path: "/succursales/:city()/:id()/",
    meta: _91id_93wf3DLQj1hXKymRRNLYKEq7aajInbp92vYHJEaPnvl5sMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/[city]/[id].vue")
  },
  {
    name: "niederlassungen-city-id___it-ch",
    path: "/filiali/:city()/:id()/",
    meta: _91id_93wf3DLQj1hXKymRRNLYKEq7aajInbp92vYHJEaPnvl5sMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/[city]/[id].vue")
  },
  {
    name: "niederlassungen-city-id___it-it",
    path: "/niederlassungen/:city()/:id()/",
    meta: _91id_93wf3DLQj1hXKymRRNLYKEq7aajInbp92vYHJEaPnvl5sMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/[city]/[id].vue")
  },
  {
    name: "niederlassungen-city-id___de-it",
    path: "/niederlassungen/:city()/:id()/",
    meta: _91id_93wf3DLQj1hXKymRRNLYKEq7aajInbp92vYHJEaPnvl5sMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/[city]/[id].vue")
  },
  {
    name: "service-gebrauchsanweisungen___de-at",
    path: "/service/gebrauchsanweisungen/",
    meta: gebrauchsanweisungenXG5Uoi_oi6TolJO_45nNdotEzuzH3cL9TNzcH9fYDMr1EMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/gebrauchsanweisungen.vue")
  },
  {
    name: "service-gebrauchsanweisungen___de-de",
    path: "/service/gebrauchsanweisungen/",
    meta: gebrauchsanweisungenXG5Uoi_oi6TolJO_45nNdotEzuzH3cL9TNzcH9fYDMr1EMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/gebrauchsanweisungen.vue")
  },
  {
    name: "service-gebrauchsanweisungen___cs-cz",
    path: "/servis/navod-k-pouziti/",
    meta: gebrauchsanweisungenXG5Uoi_oi6TolJO_45nNdotEzuzH3cL9TNzcH9fYDMr1EMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/gebrauchsanweisungen.vue")
  },
  {
    name: "service-gebrauchsanweisungen___pl-pl",
    path: "/uslugi/instrukcje-uzytkowania/",
    meta: gebrauchsanweisungenXG5Uoi_oi6TolJO_45nNdotEzuzH3cL9TNzcH9fYDMr1EMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/gebrauchsanweisungen.vue")
  },
  {
    name: "service-gebrauchsanweisungen___de-ch",
    path: "/service/gebrauchsanweisungen/",
    meta: gebrauchsanweisungenXG5Uoi_oi6TolJO_45nNdotEzuzH3cL9TNzcH9fYDMr1EMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/gebrauchsanweisungen.vue")
  },
  {
    name: "service-gebrauchsanweisungen___fr-ch",
    path: "/service/mode-demploi/",
    meta: gebrauchsanweisungenXG5Uoi_oi6TolJO_45nNdotEzuzH3cL9TNzcH9fYDMr1EMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/gebrauchsanweisungen.vue")
  },
  {
    name: "service-gebrauchsanweisungen___it-ch",
    path: "/servizi/istruzioni-per-l-uso/",
    meta: gebrauchsanweisungenXG5Uoi_oi6TolJO_45nNdotEzuzH3cL9TNzcH9fYDMr1EMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/gebrauchsanweisungen.vue")
  },
  {
    name: "service-gebrauchsanweisungen___it-it",
    path: "/service/gebrauchsanweisungen/",
    meta: gebrauchsanweisungenXG5Uoi_oi6TolJO_45nNdotEzuzH3cL9TNzcH9fYDMr1EMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/gebrauchsanweisungen.vue")
  },
  {
    name: "service-gebrauchsanweisungen___de-it",
    path: "/service/gebrauchsanweisungen/",
    meta: gebrauchsanweisungenXG5Uoi_oi6TolJO_45nNdotEzuzH3cL9TNzcH9fYDMr1EMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/gebrauchsanweisungen.vue")
  },
  {
    name: "service-konformitaetserklaerungen___de-at",
    path: "/service/konformitaetserklaerungen/",
    meta: konformitaetserklaerungenfCLHlRszuNR3hFZX8WXAQJe5e6ruph8zF_45kbJZmYDyoMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/konformitaetserklaerungen.vue")
  },
  {
    name: "service-konformitaetserklaerungen___de-de",
    path: "/service/konformitaetserklaerungen/",
    meta: konformitaetserklaerungenfCLHlRszuNR3hFZX8WXAQJe5e6ruph8zF_45kbJZmYDyoMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/konformitaetserklaerungen.vue")
  },
  {
    name: "service-konformitaetserklaerungen___cs-cz",
    path: "/servis/eu-prohlaseni-o-shode/",
    meta: konformitaetserklaerungenfCLHlRszuNR3hFZX8WXAQJe5e6ruph8zF_45kbJZmYDyoMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/konformitaetserklaerungen.vue")
  },
  {
    name: "service-konformitaetserklaerungen___pl-pl",
    path: "/uslugi/deklaracja-zgodnosci/",
    meta: konformitaetserklaerungenfCLHlRszuNR3hFZX8WXAQJe5e6ruph8zF_45kbJZmYDyoMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/konformitaetserklaerungen.vue")
  },
  {
    name: "service-konformitaetserklaerungen___de-ch",
    path: "/service/konformitaetserklaerungen/",
    meta: konformitaetserklaerungenfCLHlRszuNR3hFZX8WXAQJe5e6ruph8zF_45kbJZmYDyoMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/konformitaetserklaerungen.vue")
  },
  {
    name: "service-konformitaetserklaerungen___fr-ch",
    path: "/service/certificat-de-conformite/",
    meta: konformitaetserklaerungenfCLHlRszuNR3hFZX8WXAQJe5e6ruph8zF_45kbJZmYDyoMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/konformitaetserklaerungen.vue")
  },
  {
    name: "service-konformitaetserklaerungen___it-ch",
    path: "/servizi/dichiarazione-di-conformita/",
    meta: konformitaetserklaerungenfCLHlRszuNR3hFZX8WXAQJe5e6ruph8zF_45kbJZmYDyoMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/konformitaetserklaerungen.vue")
  },
  {
    name: "service-konformitaetserklaerungen___it-it",
    path: "/service/konformitaetserklaerungen/",
    meta: konformitaetserklaerungenfCLHlRszuNR3hFZX8WXAQJe5e6ruph8zF_45kbJZmYDyoMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/konformitaetserklaerungen.vue")
  },
  {
    name: "service-konformitaetserklaerungen___de-it",
    path: "/service/konformitaetserklaerungen/",
    meta: konformitaetserklaerungenfCLHlRszuNR3hFZX8WXAQJe5e6ruph8zF_45kbJZmYDyoMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/service/konformitaetserklaerungen.vue")
  },
  {
    name: "niederlassungen-stadt-county-city___de-at",
    path: "/niederlassungen/stadt/:county()/:city()/",
    meta: _91city_93_nxqPu8Gh_45kaDIG9RQMb2Q30uXf4f55mKFK7ebrxNwkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/stadt/[county]/[city].vue")
  },
  {
    name: "niederlassungen-stadt-county-city___de-de",
    path: "/niederlassungen/stadt/:county()/:city()/",
    meta: _91city_93_nxqPu8Gh_45kaDIG9RQMb2Q30uXf4f55mKFK7ebrxNwkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/stadt/[county]/[city].vue")
  },
  {
    name: "niederlassungen-stadt-county-city___cs-cz",
    path: "/pobocky/mesto/:county()/:city()/",
    meta: _91city_93_nxqPu8Gh_45kaDIG9RQMb2Q30uXf4f55mKFK7ebrxNwkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/stadt/[county]/[city].vue")
  },
  {
    name: "niederlassungen-stadt-county-city___pl-pl",
    path: "/salony/miasto/:county()/:city()/",
    meta: _91city_93_nxqPu8Gh_45kaDIG9RQMb2Q30uXf4f55mKFK7ebrxNwkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/stadt/[county]/[city].vue")
  },
  {
    name: "niederlassungen-stadt-county-city___de-ch",
    path: "/niederlassungen/stadt/:county()/:city()/",
    meta: _91city_93_nxqPu8Gh_45kaDIG9RQMb2Q30uXf4f55mKFK7ebrxNwkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/stadt/[county]/[city].vue")
  },
  {
    name: "niederlassungen-stadt-county-city___fr-ch",
    path: "/succursales/ville/:county()/:city()/",
    meta: _91city_93_nxqPu8Gh_45kaDIG9RQMb2Q30uXf4f55mKFK7ebrxNwkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/stadt/[county]/[city].vue")
  },
  {
    name: "niederlassungen-stadt-county-city___it-ch",
    path: "/filiali/citta/:county()/:city()/",
    meta: _91city_93_nxqPu8Gh_45kaDIG9RQMb2Q30uXf4f55mKFK7ebrxNwkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/stadt/[county]/[city].vue")
  },
  {
    name: "niederlassungen-stadt-county-city___it-it",
    path: "/niederlassungen/stadt/:county()/:city()/",
    meta: _91city_93_nxqPu8Gh_45kaDIG9RQMb2Q30uXf4f55mKFK7ebrxNwkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/stadt/[county]/[city].vue")
  },
  {
    name: "niederlassungen-stadt-county-city___de-it",
    path: "/niederlassungen/stadt/:county()/:city()/",
    meta: _91city_93_nxqPu8Gh_45kaDIG9RQMb2Q30uXf4f55mKFK7ebrxNwkMeta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/niederlassungen/stadt/[county]/[city].vue")
  },
  {
    name: "subscription-subscription-cancellations___de-at",
    path: "/spar-abo/kuendigung/",
    meta: subscription_45cancellationsbcaGWuTd1Bu0BLo_0UztD8BtWaL_45Wnctj4CEJnUJqS0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/subscription/subscription-cancellations.vue")
  },
  {
    name: "subscription-subscription-cancellations___de-de",
    path: "/spar-abo/kuendigung/",
    meta: subscription_45cancellationsbcaGWuTd1Bu0BLo_0UztD8BtWaL_45Wnctj4CEJnUJqS0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/subscription/subscription-cancellations.vue")
  },
  {
    name: "subscription-subscription-cancellations___cs-cz",
    path: "/vyhodne-predplatne/zruseni/",
    meta: subscription_45cancellationsbcaGWuTd1Bu0BLo_0UztD8BtWaL_45Wnctj4CEJnUJqS0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/subscription/subscription-cancellations.vue")
  },
  {
    name: "subscription-subscription-cancellations___pl-pl",
    path: "/abonament-oszczednosciowy/rezzygnacja/",
    meta: subscription_45cancellationsbcaGWuTd1Bu0BLo_0UztD8BtWaL_45Wnctj4CEJnUJqS0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/subscription/subscription-cancellations.vue")
  },
  {
    name: "subscription-subscription-cancellations___de-ch",
    path: "/spar-abo/kuendigung/",
    meta: subscription_45cancellationsbcaGWuTd1Bu0BLo_0UztD8BtWaL_45Wnctj4CEJnUJqS0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/subscription/subscription-cancellations.vue")
  },
  {
    name: "subscription-subscription-cancellations___fr-ch",
    path: "/abonnement-eco/resiliation/",
    meta: subscription_45cancellationsbcaGWuTd1Bu0BLo_0UztD8BtWaL_45Wnctj4CEJnUJqS0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/subscription/subscription-cancellations.vue")
  },
  {
    name: "subscription-subscription-cancellations___it-ch",
    path: "/abbonamento-risparmio/disdetta/",
    meta: subscription_45cancellationsbcaGWuTd1Bu0BLo_0UztD8BtWaL_45Wnctj4CEJnUJqS0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/subscription/subscription-cancellations.vue")
  },
  {
    name: "subscription-subscription-cancellations___it-it",
    path: "/spar-abo/kuendigung/",
    meta: subscription_45cancellationsbcaGWuTd1Bu0BLo_0UztD8BtWaL_45Wnctj4CEJnUJqS0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/subscription/subscription-cancellations.vue")
  },
  {
    name: "subscription-subscription-cancellations___de-it",
    path: "/spar-abo/kuendigung/",
    meta: subscription_45cancellationsbcaGWuTd1Bu0BLo_0UztD8BtWaL_45Wnctj4CEJnUJqS0Meta || {},
    component: () => import("/builds/aboutyou/cloud-agency/shop-application/fim-sfa/pages/subscription/subscription-cancellations.vue")
  }
]